import { useMemo as e } from "react";
import { useTrCountry as t, useTrEnumNamespace as n, useTranslation as r } from "@maat/store-i18n";
import { DateFormat as i, formatDateSafe as a } from "@maat/datetime";
//#region src/components/VerifiedIdentityBadge/hooks/useVerifiedIdentityLabel.ts
var o = " · ", s = ({ verified: s, countryCode: c, documentType: l, verifiedAt: u }) => {
	let { t: d } = r("ds"), f = t(), p = n("verificationDocumentType");
	return e(() => {
		if (!s) return d("verifiedIdentityBadge.notVerified");
		let e = a(u, i.MONTH_YEAR_LONG), t = e ? d("verifiedIdentityBadge.verifiedOn", { date: e }) : d("verifiedIdentityBadge.verified");
		return [
			c ? f(c) : void 0,
			l ? p(l) : void 0,
			t
		].filter(Boolean).join(o);
	}, [
		s,
		c,
		l,
		u,
		d,
		f,
		p
	]);
};
//#endregion
export { s as useVerifiedIdentityLabel };
